import { LogoListStatic } from 'libs/growth-platform-brand-system-v2/src/layouts/LogoListStatic';
import { morphism } from 'morphism';
import React from 'react';
import { schemaImage } from '../../morphismSchema/components/schemaImage';
import { Image } from 'libs/growth-platform-brand-system-v2/src/components/Image';

export const LogoListStaticComponent = ({ block, id, locale }: any) => {
  const logos = block.logos.map((logo: any, index: number) => {
    const logoData = morphism(schemaImage, logo);
    return (
      <Image
        key={index}
        {...logoData}
        className={'max-w-[102px]'}
        sizes="102px"
      />
    );
  });
  return <LogoListStatic logos={logos} title={block.title} />;
};
export default LogoListStaticComponent;
